import { defineRecipe as t } from "@pandacss/dev";
const e = {
  glassy: {
    backgroundColor: "alpha-white-50",
    borderColor: "alpha-white-30",
    color: "text-white",
    height: "8",
    gap: "2",
    backdropFilter: "blur(16px)"
  },
  flat: {
    backgroundColor: "bg-secondary",
    borderColor: "alpha-black-10",
    color: "text-primary",
    height: "8",
    gap: "2",
    backdropFilter: "blur(2px)"
  }
}, a = t({
  className: "property-chip-deprecated",
  base: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    paddingTop: "1.5",
    paddingBottom: "1.5",
    paddingLeft: "3",
    paddingRight: "3",
    borderRadius: "full",
    fontFamily: "inter",
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "md",
    letterSpacing: "md",
    gap: "2",
    borderWidth: "1px"
  },
  variants: {
    variant: e
  },
  defaultVariants: {
    variant: "flat"
  }
});
export {
  a as propertyChip
};
